const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof mfe_demand_growth_additional_costs !== "undefined") return resolve();
	__webpack_require__.l("https://www.immowelt.de/assets/mfes/demand_growth_additional_costs/v1/client/remoteEntry.js", (event) => {
		if(typeof mfe_demand_growth_additional_costs !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "mfe_demand_growth_additional_costs");
}).then(() => (mfe_demand_growth_additional_costs));